import { createFileRoute } from '@tanstack/react-router'

import { CategoriesPage } from '@/modules/insights/pages'

export const Route = createFileRoute(
  '/_authenticated/projects/$slug/insights/categories',
)({
  component: () => <CategoriesPage slug={Route.useParams().slug} />,
})
